import { atom } from 'jotai';
import { dataLockerPitchEventsAtom } from '@/atoms/dataLocker/vis';
import { playerPitchEventsAtom } from '@/atoms/player/vis';
import { sectionAtom } from '@/atoms/section';
import { teamPitchEventsAtom } from '@/atoms/vis/teamVis';
import { SectionAtomMap } from '@/types/section';
import { PitchEvents } from '@/types/visualisation';
import { createUnwrappedPitchEventsAtom } from '@/utils/atoms/vis';

const EMPTY_PITCH_EVENTS: PitchEvents = { markerEvents: [], arrowEvents: [] };

const pitchEventsSectionMapAtom = atom<SectionAtomMap<PitchEvents>>(() => ({
  player: playerPitchEventsAtom,
  team: teamPitchEventsAtom,
  dataLocker: dataLockerPitchEventsAtom,
}));

export const currentPitchEventsAtom = atom(async get => {
  const section = get(sectionAtom);
  const sectionMap = get(pitchEventsSectionMapAtom);
  const atomForSection = section ? sectionMap[section] : undefined;

  if (!atomForSection) return EMPTY_PITCH_EVENTS;

  return get(atomForSection);
});

export const currentUnwrappedPitchEventsAtom = createUnwrappedPitchEventsAtom(currentPitchEventsAtom);
